'use client';

import { useEventStore } from 'app/_event';
import { DefaultViewupStamp } from './DefaultViewupStamp';
import { XmasViewupStamp } from './XmasViewupStamp';

export const ViewupStamp = () => {
  const isXmas = useEventStore((s) => s.activeEvent === 'xmas');
  return isXmas ? <XmasViewupStamp /> : <DefaultViewupStamp />;
};
